import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'LfErrorListComponent',
  props: {
    errors: { type: Array, required: true },
    description: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as {
  errors: string[],
  description: string };

const { t } = useI18n()



const texts = {
  body: props.description || t('components.dialog.maintenance_errors_list_description_default').toString(),
  primaryButtonText: t('action_buttons.accept').toString()
}

const icon = computed(() => {
  return require('@/assets/images/svg/Track-Right.svg')
})


return { __sfc: true,t, props, texts, icon }
}

})